export function workspaceStorageKey(user) {
  return `cosocial-workspace-${user.id || user._id}`;
}

export function readWorkspaceSelection(user) {
  const returnedWorkspace = new URLSearchParams(window.location.search).get('workspaceId');
  if (returnedWorkspace) return returnedWorkspace;
  try { return localStorage.getItem(workspaceStorageKey(user)) || ''; }
  catch { return ''; }
}

export function resolveWorkspaceSelection(rows, selectedId) {
  return rows.find((row) => String(row.id) === String(selectedId))?.id || rows[0]?.id || '';
}

export function persistWorkspaceSelection(user, workspaceId) {
  try { localStorage.setItem(workspaceStorageKey(user), workspaceId); } catch {}
  const url = new URL(window.location.href);
  url.searchParams.set('workspaceId', workspaceId);
  window.history.replaceState(null, '', `${url.pathname}${url.search}${url.hash}`);
}
